// extracted by mini-css-extract-plugin
export var breadcrumb = "_8-0";
export var breadcrumbArrow = "_8-1";